import { onError } from '@apollo/client/link/error'

import loginTokenVar from '@emico/login-token'

import { AuthPageContextProps } from './ApolloConnector'
import { redirectToLogin } from './redirectToLogin'

export default (authPages: AuthPageContextProps) =>
  onError(({ response, graphQLErrors, operation }) => {
    if (!graphQLErrors) {
      return
    }

    const handleLoginRedirect = () => {
      loginTokenVar(undefined)
      if (operation.getContext()?.skipAuthRedirect) {
        return
      }
      const { shouldRedirect, redirect } = redirectToLogin(authPages)

      if (shouldRedirect && response) {
        // Docs: https://www.apollographql.com/docs/link/links/error/#ignoring-errors
        response.errors = undefined
        redirect?.()
      }
    }

    graphQLErrors.forEach(({ message, extensions }) => {
      if (extensions?.category === 'graphql-authentication') {
        const errors = ['The account is locked.']
        if (errors.includes(message)) {
          // do something
        }
      }
      if (extensions?.category === 'graphql-authorization') {
        const errors = ["The current customer isn't authorized."]
        if (errors.includes(message)) {
          handleLoginRedirect()
        }
      }
    if (extensions?.category === 'graphql-no-such-entity') {
        const errors = ['Customer with id "0" does not exist.']
        if (errors.includes(message)) {
          handleLoginRedirect()
        }
      }
    })
  })
